import { Status } from "./Status";

export class OperatorPermissionsLevelSmartEnum {
    static Level1 = new Status("Level 1 - CellTrak", 1, "pill--yellow");
    static Level2 = new Status("Level 2 - CellTrak", 2, "pill--green"); 
    static Level3 = new Status("Level 3 - CellTrak", 3, "pill--blue");
    static Level4 = new Status("Level 4 - CellTrak", 4, "pill--orange");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "OperatorPermissionsLevelSmartEnum";
    }
}
